import { Outlet, ScrollRestoration } from 'react-router-dom'
import { ThemeProvider } from "@/components/theme-provider"
import { NavigationProvider, useWebSocketContext, useAuth } from '@/contexts'
import { Toaster } from 'sonner'
import { Spinner } from './components/ui'

export default function App() {
  const { loading } = useWebSocketContext()
  const { isSignedIn } = useAuth()

  return (
    <ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
      <NavigationProvider>
        <Toaster />

        {isSignedIn && loading ? (
          <div className="flex justify-center items-center h-screen">
            <Spinner />
          </div>
        ) : (
          <>
            <ScrollRestoration />
            <Outlet />
          </>
        )}
      </NavigationProvider>
    </ThemeProvider>
  )
}
